import { CLINIC_LEAD_FORM_SUCCESS, CLINIC_LEAD_FORM_ERROR } from '../constants/index';

export const clinicLeadSuccess = () => ({ type: CLINIC_LEAD_FORM_SUCCESS });
export const clinicLeadError = (value: any) => ({
  type: CLINIC_LEAD_FORM_ERROR,
  payload: { value },
});
